<template>
  <div class="right mr-2">
    <Badge :dot="badgeDot" >
      <Icon type="ios-notifications" @click="modal = !modal" size="24"/>
    </Badge>
      <Modal
        v-model="modal"
        draggable
        scrollable
        footer-hide
        width="400"
        class-name="alertNotice"
        :transfer="false"
       >
        <p slot="header">
            <span>操盘纪录</span>
        </p>
        <template v-if="items.length">
          <div title="點擊查看詳細" v-for="(it, index) in items" :key="index" :class="[alertClass(it), { 'small': smallSize }, { 'default': !smallSize }]" @click="smallSize = !smallSize">
            <span class="mr-1">{{it.memname}}</span>
            <span v-if="it.state !== null">
              <span v-if="it.state.status == '1'" class="_alignmiddle" >
                <span v-show="!smallSize">修改成功</span>
                <Icon v-show="smallSize" type="ios-checkmark-circle"  />
              </span>
              <span v-else class="_alignmiddle">
                <span v-show="!smallSize">{{it.state.msg}}</span>
                <Icon v-show="smallSize" type="ios-alert"  />
              </span>
            </span>
            <span v-else>
              <span v-show="!smallSize">{{`网路异常：(S3111)`}}</span>
              <Icon v-show="smallSize" type="ios-alert"  />
            </span>
          </div>
        </template>
        <template v-if="!items.length">無操盤紀錄</template>
    </Modal>
  </div>
</template>
<script>
import errorCdoe from '@/plugins/utils/error-code'
export default {
  data() {
    return { 
      items: [],
      smallSize: false,
      modal: false
    }
  },
  computed: {
    badgeDot () {
      return this.items.length ? true : false
    }
  },
  mounted () {
    this.$Eventhub.$on('alert-notice', (it) => {
      const newit = it.map(item => {
        if (item.state.status == 0) item.state.msg = item.state.msg ? item.state.msg : errorCdoe.getErrorCodeText(item.state.code)
        return item
      })
      this.items = []
      this.items = newit
    })
  },
  BeforeDestroy () {
    this.$Eventhub.$off('alert-notice')
  },
  methods: {
    alertClass (val) {
      if(val.state == null) return { 'lida-card-alert error': true }
      return val.state.status === 1 
        ? { 'lida-card-alert success': true }
        : { 'lida-card-alert warning': true }
    }
  }
}
</script>
<style lang="scss">
.alertNotice {
  .ivu-modal-close {
    top: 4px;
  }
  .ivu-modal-header {
    padding: 8px;
    p { 
      font-size: 14px;
    }
  }
  .ivu-modal-body {
    font-size: 13px;
     padding: 8px;
  }
}
</style>